/** Assemble BoundAppShell props without bloating App.tsx */

import type { DisappearTimerSec, MessageEvent } from "@veto/domain";

export function withPollAndLockProps(
  base: Record<string, unknown>,
  extra: {
    showPollModal: boolean;
    setShowPollModal: (v: boolean) => void;
    createAndSendPoll: (q: string, opts: string[]) => Promise<void>;
    voteOnPoll: (m: MessageEvent, optionId: string) => Promise<void>;
    pendingChatLock: unknown;
    markUnlocked: (id: string) => void;
    setPendingLock: (v: null) => void;
    enableLock: (id: string, pin: string) => Promise<void>;
    openConversation: (id: string) => Promise<void>;
    setActiveId: (id: string | null) => void;
    setToast: (t: string | null) => void;
    activeId: string | null;
    disappearTimer: DisappearTimerSec;
    groupForkWarning: string | null;
    /** Conversation id whose lock-PIN modal is open (null = closed). */
    chatLockPromptFor: string | null;
    setChatLockPromptFor: (v: string | null) => void;
  },
) {
  return {
    ...base,
    disappearTimer: extra.disappearTimer,
    groupForkWarning: extra.groupForkWarning,
    onCreatePoll: () => extra.setShowPollModal(true),
    onVotePoll: (m: MessageEvent, optionId: string) => void extra.voteOnPoll(m, optionId),
    showPollModal: extra.showPollModal,
    setShowPollModal: extra.setShowPollModal,
    onSubmitPoll: (q: string, opts: string[]) => void extra.createAndSendPoll(q, opts),
    pendingChatLock: extra.pendingChatLock,
    onChatLockUnlock: () => {
      const lock = extra.pendingChatLock as { conversationId: string } | null;
      if (!lock) return;
      extra.markUnlocked(lock.conversationId);
      void extra.openConversation(lock.conversationId);
    },
    onChatLockCancel: () => {
      extra.setPendingLock(null);
      extra.setActiveId(null);
    },
    /** Details-sheet entry — opens the PIN modal (or removes the lock in chrome). */
    onToggleChatLock: () => {
      if (!extra.activeId) return;
      extra.setChatLockPromptFor(extra.activeId);
    },
    chatLockPromptFor: extra.chatLockPromptFor,
    onChatLockPromptClose: () => extra.setChatLockPromptFor(null),
    onChatLockPromptConfirm: (pin: string) => {
      const id = extra.chatLockPromptFor;
      extra.setChatLockPromptFor(null);
      if (!id) return;
      void extra
        .enableLock(id, pin)
        .then(() => extra.setToast("Chat locked (on this device)"))
        .catch(() => extra.setToast("Could not lock the chat"));
    },
  };
}
